const appConfig = {
  isDev: process.env.NODE_ENV === "development",
  appVersion: process.env.GATSBY_appVersion,
  reCaptchaSiteKey: process.env.GATSBY_reCaptchaSiteKey || "",
}

export default appConfig
